<template>
  <el-dialog
    :title="$t('history_list')"
    :visible.sync="visible"
    @open="handleOpen"
  >
    <list-table
      :columns="config.table.columns"
      :data="config.table.data"
    ></list-table>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">{{
        $t("global_button_ok")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ListTable from "../../components/table/listTable.vue";
import initConfig from "./config.js";
import { getHistory } from "@/services/fulfillment-api";

export default {
  data() {
    return {
      visible: false,
      config: {}
    };
  },
  components: {
    ListTable
  },
  methods: {
    initConfig() {
      this.config = initConfig.call(this);
    },
    async handleOpen() {
      let params = {
        order_base_id: this.$parent.editingRow.order_base_info_id
      };
      let resp = await getHistory(params);
      this.config.table.data = resp.result;
    }
  },
  created() {
    this.initConfig();
  }
};
</script>
